import { Main } from "../components";

// Category Preview
import Preview from "../components/Preview"


/*
==========
Home Page 
==========
*/


function Home() {
  return (
    <>
      {/* <Navbar /> */}
      <Main />
      <Preview />
      {/* <Footer /> */}
    </>
  )
}

export default Home